

























































import { mapGetters, mapActions } from "vuex";
import { General } from "@/utils/constants";
import { truncate } from "lodash";
import CircleLoading from "@/components/CircleLoading";
import { IGiveKnowledge } from "@/store/types/user-types";
import { SnackQueue as Queue } from "@/plugins/SnackQueue";

export default {
  name: "ListGiveKnowledge",
  components: {
    CircleLoading
  },
  data() {
    return {
      General,
      truncate
    };
  },

  computed: {
    ...mapGetters({
      getListGiveKnowledge: "getListGiveKnowledge"
    }),

    showTryButton() {
      return this.getListGiveKnowledge.some(({ status }: IGiveKnowledge) =>
        ["error", "abort"].includes(status)
      );
    }
  },

  watch: {
    getListGiveKnowledge: {
      handler() {
        this.setTitle();
      },
      deep: true
    }
  },

  beforeMount() {
    this.setTitle();
  },

  methods: {
    ...mapActions({
      tryGiveKnowledge: "tryGiveKnowledge"
    }),

    tryAgain(userIndex = "all") {
      this.tryGiveKnowledge(userIndex);
    },

    setTitle() {
      const countKnowledge = this.getListGiveKnowledge
        .filter((file: IGiveKnowledge) => file.status === "pending")
        .reduce(
          (acc: string[], actual: IGiveKnowledge) =>
            (acc.includes(actual.user.id) || acc.push(actual.user.id)) && acc,
          []
        ).length;
      let newTitle = this.General.TEXTS.GIVE_KNOWLEDGE_FINISHED;
      if (countKnowledge) {
        const mensage =
          countKnowledge === 1
            ? this.General.TEXTS.GIVE_KNOWLEDGE_QUANTITY_SINGULAR
            : this.General.TEXTS.GIVE_KNOWLEDGE_QUANTITY;
        newTitle = mensage.replace("(QUANTITY)", countKnowledge);
      } else {
        const lastFailKnowledge = [...this.getListGiveKnowledge]
          .reverse()
          .find(file => file.status === "error");
        if (lastFailKnowledge) {
          const withoutAccess =
            lastFailKnowledge.error === this.General.WITHOUT_USER_ACCESS;
          (this as any).snackToast.open({
            message: withoutAccess
              ? this.General.TEXTS.BLOCK_GIVE_KNOWLEDGE
              : this.General.TEXTS.GIVE_KNOWLEDGE_FAIL,
            type: "is-danger",
            duration: 8000
          });
        }
        Queue.open({
          id: "give_knowledge",
          canClose: true
        });
      }
      this.$emit("updateTitle", newTitle);
    }
  }
};
